import { RoutingConstants } from "src/app/constants/routingConstants";
import { AppConstants } from "./app.constants";

export const MenuConstants = {
  menuPrincipal: [
    {
      id: "Certificado",
      icon: "fas fa-car",
      nombreCompleto: "Certificado",
      profiles: [
        AppConstants.roles.ADMIN,
        AppConstants.roles.ANALISTA,
        AppConstants.roles.AAVANZA,
        AppConstants.roles.ABASICO,
        AppConstants.roles.REVISOR,
        AppConstants.roles.RHOMOLOG,
        AppConstants.roles.CONCES,
        AppConstants.roles.RREGION,
        AppConstants.roles.TECNICO,
      ],
      subMenuStatus: false,
      subMenu: [
        {
          id: "Buzón",
          icon: "fas fa-mail-bulk",
          url: RoutingConstants.certificatesMailBox.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
          ],
        },
        {
          id: "Consulta",
          icon: "fas fa-search",
          url: RoutingConstants.certificatesQuery.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
            AppConstants.roles.RREGION,
            AppConstants.roles.TECNICO,
          ],
        },
        {
          id: "Solicitud",
          icon: "fas fa-folder-plus",
          url: RoutingConstants.certificatesRequest.data,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
          ],
        },
      ],
    },
    {
      id: "CoC",
      icon: "fas fa-map",
      nombreCompleto: "CoC",
      profiles: [
        AppConstants.roles.ADMIN,
        AppConstants.roles.ANALISTA,
        AppConstants.roles.ABASICO,
        AppConstants.roles.AAVANZA,
        AppConstants.roles.REVISOR,
        AppConstants.roles.RHOMOLOG,
        AppConstants.roles.CONCES,
        AppConstants.roles.RREGION,
        AppConstants.roles.TECNICO,
      ],
      subMenuStatus: false,
      subMenu: [
        {
          id: "Buzón",
          icon: "fas fa-mail-bulk",
          url: RoutingConstants.cocMailBox.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
          ],
        },
        {
          id: "Consulta",
          icon: "fas fa-search",
          url: RoutingConstants.cocQuery.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
            AppConstants.roles.RREGION,
            AppConstants.roles.TECNICO,
          ],
        },
        {
          id: "Solicitud",
          icon: "fas fa-folder-plus",
          url: RoutingConstants.cocRequest.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
          ],
        },
      ],
    },
    {
      id: "Placa",
      icon: "fas fa-file-invoice",
      nombreCompleto: "Placa",
      profiles: [
        AppConstants.roles.ADMIN,
        AppConstants.roles.ANALISTA,
        AppConstants.roles.AAVANZA,
        AppConstants.roles.REVISOR,
        AppConstants.roles.RHOMOLOG,
        AppConstants.roles.CONCES,
        AppConstants.roles.RREGION,
        AppConstants.roles.TECNICO,
      ],
      subMenuStatus: false,
      subMenu: [
        {
          id: "Buzón",
          icon: "fas fa-mail-bulk",
          url: RoutingConstants.placaMailBox.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
          ],
        },
        {
          id: "Consulta",
          icon: "fas fa-search",
          url: RoutingConstants.placaQuery.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
            AppConstants.roles.RREGION,
            AppConstants.roles.TECNICO,
          ],
        },
        {
          id: "Solicitud",
          icon: "fas fa-folder-plus",
          url: RoutingConstants.placaRequest.data,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.CONCES,
          ],
        },
        {
          id: "Ficheros placa",
          icon: "fab fa-searchengin",
          url: RoutingConstants.placaQueryFiles.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
      ],
    },
    {
      id: "Usuario",
      icon: "fas fa-id-card",
      nombreCompleto: "Usuario",
      profiles: [
        AppConstants.roles.ADMIN,
        AppConstants.roles.ANALISTA,
        AppConstants.roles.ABASICO,
        AppConstants.roles.AAVANZA,
        AppConstants.roles.REVISOR,
        AppConstants.roles.RHOMOLOG,
        AppConstants.roles.RREGION,
        AppConstants.roles.CONCES,
        AppConstants.roles.TECNICO,
      ],
      subMenu: [
        {
          id: "Cambiar Contraseña",
          icon: "fas fa-lock",
          url: RoutingConstants.changePassword.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.RREGION,
            AppConstants.roles.CONCES,
            AppConstants.roles.TECNICO,
          ],
        },
        {
          id: "Parám. Personales",
          icon: "fas fa-user-cog",
          url: RoutingConstants.personasParams.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.RREGION,
            AppConstants.roles.CONCES,
          ],
        },
        {
          id: "Datos Personales",
          icon: "fas fa-user-edit",
          url: RoutingConstants.maintenanceUser.modDatosPers,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.RREGION,
            AppConstants.roles.CONCES,
            AppConstants.roles.TECNICO,
          ],
        },
        {
          id: "Concesionario",
          icon: "fas fa-store-alt",
          url: RoutingConstants.personalConcessionaire.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.RREGION,
            AppConstants.roles.CONCES,
          ],
        },
        {
          id: "Filtros ampliados",
          icon: "fas fa-filter",
          url: RoutingConstants.adavancedFilters.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.RREGION,
            AppConstants.roles.CONCES,
          ],
        },
      ],
    },
    {
      id: "Adm. Datos",
      icon: "fas fa-toolbox",
      nombreCompleto: "Adm. Datos",
      profiles: [
        AppConstants.roles.ADMIN,
        AppConstants.roles.ABASICO,
        AppConstants.roles.AAVANZA,
        AppConstants.roles.ANALISTA,
        AppConstants.roles.ABASICO,
        AppConstants.roles.REVISOR,
        AppConstants.roles.RHOMOLOG,
      ],
      subMenuStatus: false,
      subMenu: [
        {
          id: "Tablas",
          icon: "fas fa-table",
          url: RoutingConstants.masterTableRoutingD.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Imp. Datos Accesorio",
          icon: "fas fa-file-import",
          url: RoutingConstants.importarDatosAccesorios.upload,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Exp. Histórico Placa",
          icon: "fas fa-file-export",
          url: RoutingConstants.exportarHistoricoPlaca.download,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Datos CDT",
          icon: "fas fa-tasks",
          url: RoutingConstants.dataCDTRouting.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Patrones WLTP",
          icon: "fas fa-gas-pump",
          url: RoutingConstants.patronWltp.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
      ],
    },
    {
      id: "Adm. Sistema",
      icon: "fas fa-tools",
      nombreCompleto: "Adm. Sistema",
      profiles: [
        AppConstants.roles.ADMIN,
        AppConstants.roles.AAVANZA,
        AppConstants.roles.ANALISTA,
        AppConstants.roles.ABASICO,
        AppConstants.roles.REVISOR,
        AppConstants.roles.RHOMOLOG,
        AppConstants.roles.RREGION,
      ],
      subMenu: [
        {
          id: "Usuarios",
          icon: "fas fa-users",
          url: RoutingConstants.maintenanceUser.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.RREGION,
          ],
        },
        {
          id: "Concesionarios",
          icon: "fas fa-store-alt",
          url: RoutingConstants.concessionaireRouting.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.RREGION,
          ],
        },
        {
          id: "Tablas",
          icon: "fas fa-table",
          url: RoutingConstants.masterTableRoutingS.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Historial Placa",
          icon: "fas fa-file-export",
          url: RoutingConstants.maintenanceHistoricoBastidor.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Consulta Placa",
          icon: "fas fa-file-invoice",
          url: RoutingConstants.fsPlaca.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Reglas Buzón",
          icon: "fas fa-pencil-ruler",
          url: RoutingConstants.mailBoxRules.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Reglas Composición",
          icon: "fas fa-pencil-ruler",
          url: RoutingConstants.rulesTemplatesRouting.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Plantillas",
          icon: "fas fa-file-powerpoint",
          url: RoutingConstants.templatesRouting.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Parámetros Impresión",
          icon: "fas fa-print",
          url: RoutingConstants.printParamsRouting.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Formatos Impresión",
          icon: "fas fa-shoe-prints",
          url: RoutingConstants.printFormatsRouting.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Reglas Impresión",
          icon: "fas fa-ruler-combined",
          url: RoutingConstants.printsRulesRouting.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Reformas",
          icon: "fas fa-book",
          url: RoutingConstants.royalDecreeRouting.tree,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
      ],
    },
    {
      id: "Información",
      icon: "fas fa-info-circle",
      nombreCompleto: "Información",
      profiles: [
        AppConstants.roles.ADMIN,
        AppConstants.roles.ANALISTA,
        AppConstants.roles.ABASICO,
        AppConstants.roles.AAVANZA,
        AppConstants.roles.REVISOR,
        AppConstants.roles.RHOMOLOG,
        AppConstants.roles.RREGION,
        AppConstants.roles.CONCES,
      ],
      subMenuStatus: false,
      subMenu: [
        {
          id: "Ayuda",
          icon: "fas fa-question",
          url: RoutingConstants.ayudasGenerales.datos,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.ABASICO,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
            AppConstants.roles.RREGION,
            AppConstants.roles.CONCES,
          ],
        },
        {
          id: "Certificados",
          icon: "fas fa-stamp",
          url: RoutingConstants.certificatesStatistics.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Usos",
          icon: "fas fa-mouse",
          url: RoutingConstants.certificatesUse.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
        {
          id: "Facturación",
          icon: "fas fa-chart-bar",
          url: RoutingConstants.billingUse.list,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
      ],
    },
    {
      id: "Otros",
      icon: "fas fa-file-alt",
      nombreCompleto: "Otros",
      profiles: [
        AppConstants.roles.ADMIN,
        AppConstants.roles.ANALISTA,
        AppConstants.roles.AAVANZA,
        AppConstants.roles.REVISOR,
        AppConstants.roles.RHOMOLOG,
      ],
      subMenu: [
        {
          id: "Fichero Concesionarios",
          icon: "fas fa-file-download",
          url: RoutingConstants.descargaFicheroConcesionario.download,
          profiles: [
            AppConstants.roles.ADMIN,
            AppConstants.roles.ANALISTA,
            AppConstants.roles.AAVANZA,
            AppConstants.roles.REVISOR,
            AppConstants.roles.RHOMOLOG,
          ],
        },
      ],
    },
  ],
};
